module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row topic-video-list"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pager.loading),
      expression: "!pager.loading"
    }],
    staticClass: "topic-video-body"
  }, [(_vm.type === 'COURSE') ? _c('div', {
    staticClass: "section-title"
  }, [_vm._v("教学视频")]) : _vm._e(), _vm._v(" "), (_vm.type === 'LECTURE') ? _c('div', {
    staticClass: "section-title"
  }, [_vm._v("其他视频")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pager.videos), function(video) {
    return _c('div', {
      key: video
    }, [_c('div', {
      staticClass: "mv10 cursor hover-underline",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return video.click()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-video-camera"
    }), _vm._v("\n\t\t\t\t\t" + _vm._s(video.name) + "\n\t\t\t\t")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "mv20"
  }, [_c('NbPager', {
    attrs: {
      "pager": _vm.pager,
      "callback": _vm.refresh
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3331f13c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/scenery/video/List.vue
// module id = 969
// module chunks = 1